import React from 'react';
import { Icon } from './Icon';
interface Feature {
  title: string;
  description: string;
}
interface AIFeaturesSectionProps {
  'data-id'?: string;
  title?: string;
  subtitle?: string;
  flagImageUrl?: string;
  backgroundImageUrl?: string;
  features?: Feature[];
  accentColor?: string;
  backgroundColor?: string;
  borderColor?: string;
}
const defaultFeatures: Feature[] = [{
  title: 'Frontier intelligence, tailored to You.',
  description: "Make your AI your own. Train, distill, fine-tune, and build with the world's best open source models."
}, {
  title: 'Enterprise-grade. Agent-ready.',
  description: 'Deploy agents that execute, adapt, and deliver real results, with powerful orchestration, tooling, and safety.'
}, {
  title: 'Privacy-first.',
  description: 'Deploy and build with AI anywhere—on-premises, cloud, edge, devices, and more—while retaining full control of your data.'
}, {
  title: 'Deeply engaged solutioning and value delivery.',
  description: "Hands-on assistance from the world's foremost applied AI scientists across deployment, solutioning, safety, and beyond."
}];
export const AIFeaturesSection = ({
  'data-id': dataId,
  title = 'Your AI future belongs in your hands.',
  subtitle,
  flagImageUrl = 'https://cms.mistral.ai/assets/56971484-bbff-4ab7-9e4e-c034bc321f84.svg',
  backgroundImageUrl = 'https://cms.mistral.ai/assets/c7627522-667c-4bb5-a16c-4580f3767b64',
  features = defaultFeatures,
  accentColor = 'text-orange-500',
  backgroundColor = 'bg-orange-50',
  borderColor = 'border-orange-200'
}: AIFeaturesSectionProps) => {
  return <section className={`relative w-full ${backgroundColor} text-gray-800 py-6`} data-id="element-19">
      {/* Background Image */}
      <div className="absolute inset-0 -z-10 max-w-7xl mx-auto" data-id="element-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 h-full" data-id="element-21">
          <div className="relative h-full min-h-[500px]" data-id="element-22">
            <img src={backgroundImageUrl} alt="AI Background" className="absolute inset-0 w-full h-full object-cover" data-id="element-23" />
          </div>
          <div data-id="element-24"></div>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-24" data-id="element-25">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-12" data-id="element-26">
          {/* Left Column - Title */}
          <div className="lg:h-[700px] flex items-center py-4 lg:py-12 lg:h-[700px]" data-id="element-27">
            <div className="z-10 max-w-lg lg:sticky lg:top-1/2 lg:transform lg:-translate-y-1/2" data-id="element-28">
              <h2 className="text-4xl lg:text-5xl font-normal leading-tight text-benetton-green font-apercu" data-id="element-29">
                You're Drowning in Data But Starving for Insights
              </h2>
              <p className="mt-4 mb-4 text-lg text-gray-700 font-jakarta" data-id="element-30">
                Your eCommerce tech stack is siloed across dozens of platforms.
                Critical insights are trapped in disconnected dashboards while
                opportunities disappear.
              </p>
            </div>
          </div>
          {/* Right Column - Features */}
          <div className="relative z-10 flex-1" data-id="element-31">
            <div className={`${backgroundColor} border-t border-benetton-green border-b border-benetton-green`} data-id="element-32">
              {features.map((feature, index) => <div key={index} className={`flex flex-col gap-8 py-8 ${index > 0 ? `border-t border-benetton-green` : ''}`} data-id="element-33">
                  <h3 className="text-2xl lg:text-3xl font-normal" data-id="element-34">
                    {feature.title}
                  </h3>
                  <div className="flex items-start gap-6 max-w-md" data-id="element-35">
                    <div className={`mt-0.5 ${accentColor} flex-shrink-0`} data-id="element-36">
                      <Icon data-id="element-37" />
                    </div>
                    <p className="text-base leading-relaxed text-gray-700 font-jakarta" data-id="element-38">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};